import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/cost')({
  component: CostTelemetryMoved,
});

function CostTelemetryMoved() {
  return (
    <div className="space-y-8">
      <header>
        <p className="tracking-[var(--tracking-wide)] text-[var(--color-ink-muted)] text-[var(--text-sm)] uppercase">
          Operator-only
        </p>
        <h1 className="mt-2">Cost telemetry moved</h1>
        <p className="mt-2 max-w-prose text-[var(--color-ink-muted)] text-[var(--text-base)]">
          Platform cost, provider usage, subscriptions, and fleet operations belong in the Pirouette
          operator console. Studio admins manage studio data here.
        </p>
      </header>

      <div className="surface-elevated max-w-2xl p-6">
        <h2 className="font-[var(--font-display)] text-[var(--text-xl)]">Studio admin boundary</h2>
        <p className="mt-2 text-[var(--color-ink-muted)]">
          This screen no longer reads product-level cost telemetry from the studio app. Use the
          operator console for internal Pirouette/Tygart Nexus administration.
        </p>
        <Link
          to="/admin"
          className="mt-5 inline-flex rounded-[var(--radius-md)] bg-[var(--color-accent)] px-4 py-2 font-medium text-[var(--color-accent-contrast)] text-[var(--text-sm)]"
        >
          Back to studio overview
        </Link>
      </div>
    </div>
  );
}
